import { FC, useContext, useState } from 'react';

import { useMutation } from '@apollo/client';
import { Button, H2, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { IResetUserPasswordResponse, RESET_USER_PASSWORD } from 'schemas';

import notification from '../../services/notificationService';
import { IResetPasswordModal } from './interfaces';
import s from './ResetPasswordModal.module.scss';

export const ResetPasswordModal: FC<IResetPasswordModal> = ({
  onClose,
  currentClient,
  clientUUID,
}) => {
  const { t } = useContext(LocalizationContext);

  const [requestError, setRequestError] = useState<boolean>(false);
  const [resetPassword, { loading: resetPasswordLoading }] =
    useMutation<IResetUserPasswordResponse>(RESET_USER_PASSWORD, {
      onCompleted: () => {
        notification.info({
          t,
          title: t('reset.password.notification.success'),
          type: 'success',
          dismiss: 5,
        });
        onClose();
      },
      onError: () => {
        setRequestError(true);
        notification.info({
          t,
          title: t('server.error'),
          type: 'error',
          dismiss: 5,
        });
      },
    });

  return (
    <Modal onClose={onClose} className={s.modal}>
      <div className={s.header}>
        <H2>{t('permission.name.user_password_reset')}</H2>
        {requestError ? (
          <p className={s.text}>{t('server.error')}</p>
        ) : (
          <>
            <p className={s.text}>
              {t('reset.password.modal.text_1')}{' '}
              {currentClient?.first_name || currentClient?.nickname}?
            </p>
            <p className={s.text}>{t('reset.password.modal.text_2')}</p>
          </>
        )}
      </div>
      <div className={s.buttons_block}>
        {requestError ? (
          <Button
            fullWidth
            variant="primary"
            isLoading={resetPasswordLoading}
            onClick={() => {
              resetPassword({ variables: { uuid: clientUUID } });
            }}
          >
            {t('try.again')}
          </Button>
        ) : (
          <>
            <Button fullWidth variant="outline" onClick={onClose}>
              {t('notifyService.confirm.decline')}
            </Button>
            <Button
              fullWidth
              isLoading={resetPasswordLoading}
              variant="primary"
              onClick={() => {
                resetPassword({ variables: { uuid: clientUUID } });
              }}
            >
              {t('notifyService.confirm.accept')}
            </Button>
          </>
        )}
      </div>
    </Modal>
  );
};
